import { render, staticRenderFns } from "./InvestorProfile.vue?vue&type=template&id=6f8650d2&"
import script from "./InvestorProfile.vue?vue&type=script&lang=js&"
export * from "./InvestorProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports